import { css } from '@/styled-system/css';

// Mobile header styles
export const headerNavMobileStyles = css.raw({
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `height: 42px` falls between `1000` (40px) and `1100` (44px) on the numeric sizes scale
  height: '42px',
  position: 'relative',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
  // oxlint-disable-next-line constellation/no-raw-color-values
  backgroundColor: 'white',
  lg: {
    display: 'none',
  },
});

// Desktop header wrapper
export const headerNavDesktopStyles = css.raw({
  display: 'none',
  lg: {
    display: 'block',
    '& header': {
      width: '100%',
      // oxlint-disable-next-line constellation/no-raw-color-values
      backgroundColor: 'white',
    },
  },
});

// Desktop navigation styles
export const headerNavStyles = css.raw({
  width: '100%',
  height: '1400',
  paddingInline: 'default',
  boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
  display: 'flex',
  alignItems: 'center',
});

// Logo wrapper
export const logoWrapperStyles = css.raw({
  display: 'inline-block',
  marginRight: 'default',
  verticalAlign: 'text-bottom',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `width: 110px` falls between `2600` (104px) and `3600` (144px) on the numeric sizes scale
  width: '110px',
  position: 'relative',
  top: '-100',
});

// Mobile logo
export const mobileLogoStyles = css.raw({
  height: '600',
  marginLeft: 'tight',
});

// Nav list (for List.Root)
export const navListStyles = css.raw({
  display: 'inline-flex',
  alignItems: 'center',
  height: '100%',
  listStyle: 'none',
  margin: 0,
  padding: 0,
});

// Nav list item (for List.Item)
export const navListItemStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  margin: 0,
  padding: 0,
});

// Nav menu item (link)
export const navMenuItemStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  paddingInline: 'tight',
  margin: 0,
  textDecoration: 'none',
  letterSpacing: '0.5px',
  '&.active a': {
    color: 'text.neutral',
  },
});

export const navMenuLinkStyles = css.raw({
  textDecoration: 'none',
  color: 'text.subtle',
  '&:visited': {
    color: 'text.subtle',
  },
  '&:hover': {
    color: 'text.neutral',
  },
});

// Login status container
export const loginStatusStyles = css.raw({
  position: 'absolute',
  top: 0,
  right: 0,
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 150px` falls between `3600` (144px) and `4000` (160px) on the numeric sizes scale
  minWidth: '150px',
  textAlign: 'right',
  height: '1000',
  lgDown: {
    lineHeight: '40px',
  },
  lg: {
    // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 172px` falls between `4000` (160px) and `5000` (200px) on the numeric sizes scale
    minWidth: '172px',
    height: '1400',
  },
  '& a': {
    textDecoration: 'none',
    letterSpacing: '0.5px',
  },
});

// Manage properties link (desktop only)
export const managePropertiesStyles = css.raw({
  display: 'none',
  xl: {
    borderRight: '1px solid',
    // oxlint-disable-next-line constellation/prefer-semantic-tokens -- pre-existing base-token usage; was warn-only under ESLint's pandaLint
    borderColor: 'gray.400',
    display: 'inline-block',
    paddingRight: 'tight',
    marginRight: 'tight',
  },
});

// Mobile right section
export const navMobileRightStyles = css.raw({
  height: '100%',
  display: 'inline-block',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `width: 70px` falls between `1700` (68px) and `1800` (72px) on the numeric sizes scale
  width: '70px',
});

// Login status link/button
export const loginStatusLinkStyles = css.raw({
  height: '100%',
  display: 'inline-block',
  paddingRight: '400',
  lg: {
    lineHeight: '56px',
  },
});

// Profile icon
export const profileIconStyles = css.raw({
  width: '400',
  height: '400',
  marginRight: '150',
  top: '-25',
  position: 'relative',
  verticalAlign: 'middle',
});
